<div class="checkbox-container" [class.inline]="inline()">
  <label class="checkbox-label" [for]="id()">
    <input
      type="checkbox"
      [id]="id()"
      [checked]="checked()"
      [disabled]="disabled()"
      (change)="onCheckedChange($event)"
      class="checkbox-input"
    />
    @if (label()) {
      <span class="checkbox-text">{{ label() }}</span>
    }
  </label>
</div>
